module.exports = __webpack_public_path__ + "img/qtd.58d0fb8f.png";